let cachedTranslations = null;

/**
 * Retrieves and caches translations from a data attribute in the context element.
 * @param {HTMLElement} context - The section container element.
 * @returns {Object} - The translations object.
 */
export const getTranslations = (context) => {
  if (cachedTranslations) return cachedTranslations;

  const el = context.querySelector('[data-translations-json]');
  if (!el) {
    console.warn('Store locator translations JSON not found');
    return {};
  }
  cachedTranslations = JSON.parse(el.textContent || '{}');
  return cachedTranslations;
};
